// utils/environment.js

export const ENVIRONMENTS = {
  LOCAL: "local",
  DEV: "dev",
  QA: "qa",
  UAT: "uat",
  PROD: "prod",
};

export const getCurrentEnvironment = () => {
  const { hostname } = window.location;

  // Localhost
  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1"
  ) {
    return ENVIRONMENTS.LOCAL;
  }

  // Dev
  if (hostname.includes("dev.skillsbridge.ai")) {
    return ENVIRONMENTS.DEV;
  }

  // QA
  if (hostname.includes("qa.skillsbridge.ai")) {
    return ENVIRONMENTS.QA;
  }

  // UAT
  if (hostname.includes("uat.skillsbridge.ai")) {
    return ENVIRONMENTS.UAT;
  }

  // Prod
  if (
    hostname.includes("skillsbridge.ai") &&
    !hostname.includes("dev") &&
    !hostname.includes("qa") &&
    !hostname.includes("uat")

  ) {
    return ENVIRONMENTS.PROD;
  }

  return null;
};
